<template>
  <div id="app">
    <Header/>
    <div class="content">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer"
export default {
  name: "App",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  components: {
    Header: Header,
    Footer: Footer
  }
};
</script>

<style>
#app {
  font-family: PingFangSC-Regular, "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;
  min-width: 1100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue